import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'QUIERO MI BIBLIA DE LA MILANESA',
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href="https://checkout.ebookpoint.shop/cart/59446015131729:1" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block bg-dorado hover:bg-dorado-hover text-bordo-dark font-bold py-4 px-8 rounded-full shadow-lg text-lg md:text-xl transition-colors w-full md:w-auto uppercase tracking-wide text-center ${className}`} data-id="element-58">
      {text}
    </motion.a>;
}